import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    authenticated: false,
    token: "",
    loginError: "",
    signupError: "",
    signupSuccess: false
  },
  plugins: [
    new VuexPersistence({
      reducer: state => ({
        token: state.token,
        authenticated: state.authenticated
      })
    }).plugin
  ],
  mutations: {
    login(state) {
      state.pending = true;
    },
    logout(state) {
      state.token = "";
      state.authenticated = false;
    },
    signup(state) {
      state.signupSuccess = false;
      state.pending = true;
    },
    signupError(state, msg) {
      state.signupError = msg;
    },
    signupSuccess(state) {
      state.signupError = "";
      state.signupSuccess = true;
    },

    loginError(state, msg) {
      state.loginError = msg;
    },
    loginSuccess(state, token) {
      state.loginError = "";
      state.token = token;
      state.authenticated = true;
    },
    clearErrors(state) {
      state.signupError = "";
      state.signupSuccess = "";
      state.loginError = "";
    }
  },
  actions: {
    clearErrors({ commit }) {
      commit("clearErrors");
    },
    logout({ commit }) {
      commit("logout");
    },
    login: ({ commit }, creds) =>
      new Promise(resolve => {
        commit("login");
        const body = { ...creds };
        axios
          .post(`${process.env.VUE_APP_API_URL}login`, body)
          .then(response => {
            commit("loginSuccess", response.data.token);
            resolve();
          })
          .catch(err => {
            const msg = err.response.data.msg
              ? err.response.data.msg
              : "Could not login. Please try again.";
            commit("loginError", msg);
            resolve();
          });
      }),

    signup: ({ commit }, creds) =>
      new Promise(resolve => {
        commit("signup");
        const body = { ...creds };
        axios
          .post(`${process.env.VUE_APP_API_URL}signup`, body)
          .then(() => {
            commit("signupSuccess");
            resolve();
          })
          .catch(err => {
            const msg = err.response.data.msg
              ? err.response.data.msg
              : "Could not sign up. Please try again.";
            commit("signupError", msg);
            resolve();
          });
      })
  },

  getters: {
    authenticated: state => state.authenticated,
    token: state => state.token,
    signupError: state => state.signupError,
    signupSuccess: state => state.signupSuccess,
    loginError: state => state.loginError,
    config: state => {
      return {
        headers: {
          "x-access-token": state.token
        }
      };
    }
  }
});
